/**
 *  Created by pw on 2021/3/11 下午12:57.
 */
import { __assign } from "tslib";
import { app } from '@ekuaibao/whispered';
export function newTrack(key, options) {
    var _a, _b, _c;
    var staff = (_a = app.getState()['@common'].userinfo) === null || _a === void 0 ? void 0 : _a.staff;
    window.TRACK &&
        window.TRACK(key, __assign({ source: window.__PLANTFORM__, companyId: (_b = staff === null || staff === void 0 ? void 0 : staff.corporation) === null || _b === void 0 ? void 0 : _b.id, corName: (_c = staff === null || staff === void 0 ? void 0 : staff.corporation) === null || _c === void 0 ? void 0 : _c.name, userId: staff === null || staff === void 0 ? void 0 : staff.userId, userName: staff === null || staff === void 0 ? void 0 : staff.name, time: new Date().getTime() }, options));
}
